import { ActionComplaintsComponent } from "./action/action-complaints.component";
import { CreateComplaintsComponent } from "./create/create-complaints.component";
import { ViewComplaintsComponent } from "./view/view-complaints.component";

export const ComplaintsRouting = [
    { path: '', redirectTo: 'view-complaint', pathMatch: 'full' },
    { path: 'create-complaint', component: CreateComplaintsComponent},
    { path: 'view-complaint', component: ViewComplaintsComponent},
    { path: 'action-complaint/:complaintRefID', component: ActionComplaintsComponent},
]

// export const ComplaintbreadCrumbs = [
//     {name:'Create',path:'/create-complaint'},
//     {name:'View',path:'/view-complaint'},
//     {name:'Action',path:'/action-complaint'},
    
// ]